import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetTransferRepository } from "./repository/asset-transfers.repository";
import { AssetTransfersController } from "./asset-transfers.controller";
import { AssetTransfersService } from "./asset-transfers.service.ts";
import { AssetTransfersAdapter } from "./dto/asset-transfers.adapter.ts";
import { AssetTransfer } from "./entity/asset-transfer.entity";
import { UnitcodeService } from "@gtpl/shared-services/masters";
import { UserService } from "@gtpl/shared-services/attendance";

@Module({
    imports : [
        TypeOrmModule.forFeature([AssetTransfer,AssetTransferRepository]),
    ],
    controllers : [AssetTransfersController],
    providers : [AssetTransfersService,AssetTransfersAdapter,ApplicationExceptionHandler,UnitcodeService,UserService],
    exports: [AssetTransfersService]
})

export class AssetTransfersModule {}